import React, { useMemo } from 'react'
import { Link } from 'gatsby'
import { BlocksContent } from '@strapi/blocks-react-renderer'

import {
  CardWrapper,
  CardBackground,
  CardDescription,
  CardTitle,
  CardContainer,
  CardContent,
} from './styles'
import BlockTextRender from '../../components/BlockTextRender'
import ResposiveImage, { IMedia } from '../../../ResposiveImage'
import ResposiveVideo from '../../../ResposiveVideo'
import { Overlay } from '../../components/PageBuilderSection/styles'

export interface CardSectionProps {
  data: {
    title: BlocksContent
    description: BlocksContent
    link: string
    desktopImage: IMedia
    desktopVimeoId: string
    mobileImage: IMedia
    mobileVimeoId: string
  }
}

const CardSection: React.FC<CardSectionProps> = props => {
  const {
    title,
    description,
    desktopImage,
    mobileImage,
    desktopVimeoId,
    mobileVimeoId,
  } = props.data

  return (
    <CardWrapper className="card-section">
      <CardContainer className="section-container">
        <Overlay />
        <CardBackground className="card-background">
          <ResposiveImage desktop={desktopImage} mobile={mobileImage} />
          <ResposiveVideo
            desktopId={desktopVimeoId}
            mobileId={mobileVimeoId}
            muted
            loop
            playerOptions={{
              controls: false,
              autoplay: true,
              playsinline: true,
            }}
          />
        </CardBackground>
        <CardContent className="card-content">
          <CardTitle className="card-title">
            <BlockTextRender content={title} />
          </CardTitle>

          <CardDescription className="card-description">
            <BlockTextRender content={description} />
          </CardDescription>
        </CardContent>
      </CardContainer>
    </CardWrapper>
  )
}

export default CardSection
